import React, { useState, useEffect } from "react";
import { loadSection } from "../../services/contentSource";
import skillsFallback from "../../data/home/skills.json";

const SkillSection = () => {
  const [data, setData] = useState<any>(skillsFallback);
  const [activeTab, setActiveTab] = useState<string>("pills-1");

  useEffect(() => {
    loadSection("skills", skillsFallback as any)
      .then(({ data: main }) => {
        if (main) {
          setData(main);
          if ((main as any)?.skills?.[0]?.id) {
            setActiveTab((main as any).skills[0].id);
          }
        }
      })
      .catch((err) => {
        console.warn("Using fallback skills data:", err);
      });
  }, []);

  if (!data) return null;

  const currentSkill = (data.skills || []).find((s: any) => s.id === activeTab) || (data.skills || [])[0];

  return (
    <section className="skill-area mx-skill-revamp" id="skills">
      <div className="container mx-container">
        <div className="mx-skill-header">
          <div className="mx-hero-badge">
            <span className="mx-hero-badge-icon">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path>
              </svg>
            </span>
            <span>{data.badgeText || "03. VALUES & TECHNICAL MASTERY"}</span>
          </div>

          <h2 className="mx-skill-title">
            {data.title || "ELEVATE YOUR BUSINESS WITH OUR CORE VALUES"}
          </h2>

          <p className="mx-skill-lede">
            {data.subtitle || "Add top-tier engineering talent, agile technical leadership, and seamless involvement."}
          </p>
        </div>

        <div className="mx-skill-grid">
          {/* Left Column: 4 Interactive Value Tabs */}
          <div className="mx-skill-nav-column">
            {(data.skills || []).map((skill: any, index: number) => {
              const isActive = activeTab === skill.id;
              const padIndex = String(index + 1).padStart(2, "0");

              return (
                <button
                  type="button"
                  key={skill.id}
                  className={`mx-skill-item ${isActive ? "mx-skill-item-active" : ""}`}
                  onClick={() => setActiveTab(skill.id)}
                >
                  <div className="mx-skill-item-num">{padIndex}</div>
                  <div className="mx-skill-item-content">
                    <div className="mx-skill-item-title-row">
                      <h3 className="mx-skill-item-title">{skill.title}</h3>
                      {isActive && <span className="mx-skill-item-active-pill">ACTIVE FOCUS</span>}
                    </div>
                    <p className="mx-skill-item-desc">{skill.description}</p>
                  </div>
                  <div className="mx-skill-item-icon">
                    <img className="show-light" src={skill.icon?.light} alt="icon" loading="lazy" decoding="async" />
                    <img className="show-dark" src={skill.icon?.dark} alt="icon" loading="lazy" decoding="async" />
                  </div>
                </button>
              );
            })}
          </div>

          {/* Right Column: Active Value Showcase Visual Card */}
          <div className="mx-skill-visual-column">
            {currentSkill && (
              <div className="mx-skill-showcase-card">
                <div className="mx-skill-showcase-img-wrap">
                  <img
                    src={currentSkill.images?.main}
                    alt={currentSkill.title}
                    className="mx-skill-showcase-img"
                    loading="lazy"
                    decoding="async"
                  />
                  <div className="mx-skill-showcase-overlay"></div>
                </div>

                {/* Glassmorphic Overlay Telemetry */}
                <div className="mx-skill-showcase-badge-top">
                  <span className="mx-about-dot-pulse"></span>
                  <span>ENTERPRISE PRINCIPLE // {currentSkill.title.toUpperCase()}</span>
                </div>

                <div className="mx-skill-showcase-info-bottom">
                  <div className="mx-skill-showcase-headline">{currentSkill.title}</div>
                  <p className="mx-skill-showcase-sub">{currentSkill.description}</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SkillSection;
